export const WarehouseTypeEnum = {
    SILO: 'SILO',
    PORTO: 'PORTO',
    ESCRITORIO: 'ESCRITORIO',
    FABRICA: 'FABRICA'
};
